import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SchedulerPageComponent } from '../instance/components/scheduler-page/scheduler-page.component';

const routes: Routes = [
    {
        path: '',
        component: SchedulerPageComponent,
    },
    {
        path: '**',
        redirectTo: ''
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class SchedulerRoutingModule { }
